import { t } from "@/i18n-js/instance";
import { toLocaleString } from "@circle-react/helpers/number";
import type { ApiUsageDetails } from "@circle-react/types/UsageBilling";
import { calculateProgress } from "../billingUtils";
import { UsageMetric } from "./UsageMetric";

const localeRoot = "settings.billing.manage_billing.usage_details.api";

interface HeadlessApiMetricProps {
  details: ApiUsageDetails | null;
}

export const HeadlessApiMetric = ({ details }: HeadlessApiMetricProps) => {
  if (!details) {
    return null;
  }

  const { limit, usage } = details;

  return (
    <UsageMetric
      title={t(`${localeRoot}.member_api_requests.title`)}
      progress={calculateProgress(limit, usage)}
      description={t(`${localeRoot}.member_api_requests.description`, {
        current_usage: toLocaleString(usage),
        total_usage: toLocaleString(limit),
      })}
    />
  );
};
